import React from 'react';
import TopDiv from './TopDiv';
import Biography from './Biography';
import CoverLetter from './CoverLetter';
import SocialMedia from './SocialMedia';
import PersonalInfo from './PersonalInfo';
import ResumeDownload from './ResumeDownload';
import ContactInfo from './ContactInfo';
import { Card, CardContent } from '@/Components/ui/card';
import { Stack, Inline } from '@/Components/ui/layout';
import { Separator } from '@/Components/ui/separator';

function EmployerProfilePage() {
  return (
    <Card className="justify-center rounded-xl bg-white flex flex-col p-12 max-w-full overflow-hidden relative -mt-[100px]">
      <CardContent className="p-0">
        <TopDiv />
        <Inline spacing="xl" className="mt-10 items-start gap-10 justify-start flex-wrap max-w-[1000px] w-full">
          <div className="flex min-w-[240px] flex-col w-[536px]">
            <Biography />
            <Separator className="bg-slate-200 min-h-[1px] my-8 w-full border border-slate-200" />
            <CoverLetter />
            <Separator className="bg-slate-200 min-h-[1px] my-8 w-full border border-slate-200" />
            <SocialMedia />
          </div>
          <div className="flex min-w-[240px] flex-col w-[312px] ml-[50px]">
            <PersonalInfo />
            <ResumeDownload />
            <ContactInfo />
          </div>
        </Inline>
      </CardContent>
    </Card>
  );
}

export default EmployerProfilePage;